"use client";
const m = ({ callback: a, delay: i }) => {
  let e, t, s = i;
  const r = () => clearTimeout(e), c = () => {
    r(), s -= (/* @__PURE__ */ new Date()).getTime() - t;
  }, n = () => {
    t = (/* @__PURE__ */ new Date()).getTime(), e = setTimeout(a, s);
  };
  return n(), {
    clear: r,
    pause: c,
    resume: n
  };
};
export {
  m as setTimer
};
